export const Message = {
    DEFAULT_ERROR: 'We are currently experiencing processing issues, sorry for the inconvenience',
    SOMETHING_WENT_WRONG: 'Something went wrong. Your transaction did not go through',

    SWAP_TOKENS_SUCCESS: 'Successfully swapped tokens!',
    SWAP_TOKENS_ERROR: 'Tokens could not be swapped now. Try again later',

    SUPPLY_ORDER_PLACED: 'Successfully placed your order on blockchain',
    TRANSACTION_COMPLETED: 'Supply transaction was completed',
    WITHDRAWAL_TRANSACTION_COMPLETED: 'Withdrawal transaction was completed',

    GET_BALANCE_ERROR: 'Could not get balance info, sorry for the inconvenience',
    GET_EXCHANGE_INFO_ERROR: 'Could not get exchange info, sorry for the inconvenience',
    GET_GAS_ERROR: 'Could not get gas info, sorry for the inconvenience',
    GET_POOL_ERROR: 'Could not get pool info, sorry for the inconvenience',

    CHANGE_NETWORK_ERROR: 'Could not change the network. Please, try again',

    PENDING_TEXT: 'Your request will take sometime for processing',

    TAKE_LEVERAGE_SUCCESS: 'Successfully took leverage',

    CLOSE_MARGIN_ACCOUNT_ERROR: 'Could not close this account',
    CLOSE_MARGIN_ACCOUNT_SUCCESS: 'Initiated closure of margin account',

    MARGIN_ACCOUNT_IN_CLUSTER: 'This margin account is currently part of a managed cluster',
    CONTACT_SUPPORT: 'To make changes, please get in touch with support for further assistance',

    TRANSACTION_CANCELLED: 'You declined the signature request in your wallet',
    REQUEST_EXPIRED:
        'The transactions was not confirmed in time. Network must be slow or congested',
};
